export const rankingData = [
  { id: 1, rank: 1, title: '我独自升级', author: 'DUBU(REDICE STUDIO)', genre: '韩漫·热血', hot: '328万', isHot: true, change: 'up' },
  { id: 2, rank: 2, title: '剑尊归来', author: 'STUDIO LICO', genre: '韩漫·武侠', hot: '296万', isHot: true, change: 'up' },
  { id: 3, rank: 3, title: '全职猎人', author: '富坚义博', genre: '日漫·冒险', hot: '271万', isHot: false, change: 'same' },
  { id: 4, rank: 4, title: '斗破苍穹', author: '天蚕土豆', genre: '国漫·玄幻', hot: '254万', isHot: true, change: 'up' },
  { id: 5, rank: 5, title: '咒术回战', author: '芥见下下', genre: '日漫·战斗', hot: '239万', isHot: false, change: 'down' },
  { id: 6, rank: 6, title: '某天成为公主', author: 'SPOON', genre: '韩漫·恋爱', hot: '218万', isHot: true, change: 'up' },
];

export const faqData = [
  { id: 1, question: '虫虫动漫的漫画资源来自哪里？', answer: '虫虫动漫聚合了韩漫、日漫、国漫三大分类的热门作品，所有资源经过精心筛选与分类整理，确保读者能够快速找到自己喜欢的漫画类型。我们持续追踪各大漫画平台的最新更新，第一时间同步热门作品。' },
  { id: 2, question: '阅读漫画需要付费吗？', answer: '虫虫动漫目前所有漫画均可免费在线阅读，无需注册或订阅。我们采用下拉式滚动浏览模式，让阅读体验更加流畅自然，没有翻页打断，一口气看个痛快。' },
  { id: 3, question: '支持哪些设备阅读？', answer: '虫虫动漫全面适配桌面端、平板和手机浏览器，无论你是在电脑前摸鱼、躺在床上刷手机还是用平板追漫，都能获得舒适的阅读体验。下拉式阅读在移动端尤其方便，单手即可操作。' },
  { id: 4, question: '漫画更新频率如何？', answer: '热门连载漫画通常每周更新，我们会密切跟踪各大平台的发布节奏，确保在第一时间同步。韩漫一般每周二、五更新较多，日漫集中在周三、周四，国漫更新时间相对灵活。建议收藏喜欢作品，随时关注更新动态。' },
  { id: 5, question: '如何找到想看的漫画？', answer: '虫虫动漫提供按韩漫、日漫、国漫三大分类浏览，同时支持热度排行、专题合集、话题标签等多种发现方式。首页的热门推荐和榜单也能帮你发现当下最受欢迎的作品，选漫不再纠结。' },
  { id: 6, question: '可以离线下载漫画吗？', answer: '目前虫虫动漫为纯在线阅读平台，暂不支持离线下载功能。不过我们的页面加载速度经过优化，在网络环境较好的情况下，下拉式阅读几乎感受不到加载延迟，流畅的在线阅读体验同样出色。' },
];

export const contactData = {
  title: '联系我们',
  description: '如果你有漫画推荐、内容建议或合作意向，欢迎通过以下方式联系我们。虫虫动漫始终期待与读者和创作者保持紧密联系，共同打造更好的漫画阅读社区。',
  email: 'contact@chongchongcomic.com',
  wechat: '虫虫动漫小助手',
  qq: '群号 888888888',
};

export const aboutData = {
  title: '关于虫虫动漫',
  paragraphs: [
    '虫虫动漫诞生于对漫画的无限热爱。我们深知漫画爱好者在海量资源中筛选心仪作品的困扰——分类杂乱、更新滞后、阅读体验割裂。于是，一个专注于韩漫、日漫、国漫三大核心品类的漫画聚合平台应运而生。',
    '我们坚持"分类清晰、更新及时、阅读流畅"三大原则，从韩国热血漫到日本经典少年漫，从国产玄幻到都市恋爱，每一部作品都经过精心筛选。下拉式滚动浏览模式让你告别翻页打断，沉浸在连续阅读的快感中。',
    '无论你是追更党还是补番人，虫虫动漫都希望成为你漫画之旅中最贴心的伙伴。每天都有新内容，每部作品都值得期待。',
  ],
};

export const commentsData = [
  { id: 1, name: '漫画迷小王', avatar: '王', content: '韩漫分类做得太赞了！以前找韩漫要翻好几个站，现在直接在虫虫动漫就能看，而且下拉式阅读真的很舒服，不用一直点翻页，太适合一口气追完了。', rating: 5, date: '2026-07-25', genre: '韩漫读者' },
  { id: 2, name: '二次元老司机', avatar: '老', content: '日漫资源很齐全，从经典老番到新连载都有。分类清晰，想找什么类型的漫画一目了然。下拉式浏览确实比传统翻页爽，特别是看长篇的时候。', rating: 5, date: '2026-07-22', genre: '日漫读者' },
  { id: 3, name: '国漫铁粉', avatar: '国', content: '国漫这几年发展太快了，虫虫动漫的国漫区更新速度让我很满意。《斗破苍穹》《完美世界》这些热门作品基本同步更新，下拉阅读在手机上特别方便，上班摸鱼神器。', rating: 4, date: '2026-07-20', genre: '国漫读者' },
];

export const indexData = [
  { id: 1, title: '韩漫热榜TOP50', desc: '当下最热门的韩国漫画一次看够', count: 50, color: 'bg-primary-500' },
  { id: 2, title: '日漫经典殿堂', desc: '跨越时代的日本漫画经典之作', count: 120, color: 'bg-accent-500' },
  { id: 3, title: '国漫崛起力作', desc: '国产漫画精品推荐，见证国漫力量', count: 85, color: 'bg-secondary-500' },
  { id: 4, title: '恋爱甜漫专区', desc: '少女心爆棚的甜蜜恋爱漫画合集', count: 96, color: 'bg-primary-400' },
  { id: 5, title: '热血战斗漫', desc: '燃到炸裂的热血战斗漫画大合集', count: 78, color: 'bg-accent-400' },
  { id: 6, title: '悬疑惊悚馆', desc: '烧脑又刺激的悬疑推理漫画精选', count: 42, color: 'bg-secondary-600' },
  { id: 7, title: '新番速递', desc: '本周最新上架的漫画作品一览', count: 35, color: 'bg-primary-300' },
  { id: 8, title: '完结佳作', desc: '已完结的高评分漫画，一次看完全本', count: 200, color: 'bg-accent-300' },
];

export const cardsData = [
  { id: 1, title: '韩漫：从网漫到全球现象', desc: '韩国网络漫画凭借独特的竖屏滚动格式和精良的全彩作画，已从本土走向世界。虫虫动漫收录最热门韩漫作品，带你领略K-Webtoon的魅力。', tag: '韩漫文化', imgSeq: 'card-kr-01' },
  { id: 2, title: '日漫：跨越百年的漫画王国', desc: '日本漫画承载着几代人的青春记忆，从少年JUMP到青年漫画，丰富的题材和深度的叙事让日漫成为不可替代的文化符号。', tag: '日漫经典', imgSeq: 'card-jp-01' },
  { id: 3, title: '国漫：东方美学的数字新生', desc: '国产漫画正经历前所未有的黄金时代，融合中国传统文化与现代审美，从玄幻仙侠到都市现实，国漫的叙事边界不断拓展。', tag: '国漫崛起', imgSeq: 'card-cn-01' },
  { id: 4, title: '下拉式阅读：重新定义看漫画', desc: '传统的翻页阅读正在被下拉式滚动取代。无需点击，只需滑动手指或滚轮，画面自然衔接，带来沉浸式连续阅读体验。', tag: '阅读体验', imgSeq: 'card-scroll-01' },
  { id: 5, title: '漫画分类指南：找到你的菜', desc: '面对海量漫画不知从何看起？从热度排行到标签筛选，虫虫动漫的多维分类系统帮你精准定位心仪作品。', tag: '选漫攻略', imgSeq: 'card-guide-01' },
];

export const mediaData = [
  { id: 1, title: '《我独自升级》动画化决定', desc: '现象级韩漫改编动画即将上线，制作阵容豪华', tag: '韩漫', imgSeq: 'media-kr-01' },
  { id: 2, title: 'JUMP新连载引发热议', desc: '周刊少年JUMP最新连载作品首话好评如潮', tag: '日漫', imgSeq: 'media-jp-01' },
  { id: 3, title: '国产漫改剧再添力作', desc: '多部热门国漫IP确认影视化改编，期待值拉满', tag: '国漫', imgSeq: 'media-cn-01' },
  { id: 4, title: '2026夏季新番推荐', desc: '本季最值得追的漫画新作大盘点，不容错过', tag: '推荐', imgSeq: 'media-new-01' },
];

export const topicsData = [
  { id: 1, name: '#韩漫推荐', heat: '328万' },
  { id: 2, name: '#日漫经典', heat: '296万' },
  { id: 3, name: '#国漫崛起', heat: '271万' },
  { id: 4, name: '#热血战斗', heat: '254万' },
  { id: 5, name: '#甜宠恋爱', heat: '239万' },
  { id: 6, name: '#悬疑推理', heat: '218万' },
  { id: 7, name: '#玄幻仙侠', heat: '205万' },
  { id: 8, name: '#新番速递', heat: '188万' },
  { id: 9, name: '#完结佳作', heat: '175万' },
  { id: 10, name: '#漫画改编', heat: '162万' },
];

export const updatesData = [
  { id: 1, date: '07-28', title: '《剑尊归来》第128话更新', desc: '华山派与魔教的大战进入白热化阶段', tag: '韩漫更新' },
  { id: 2, date: '07-28', title: '《咒术回战》第262话更新', desc: '宿傩与五条的终极对决迎来转折', tag: '日漫更新' },
  { id: 3, date: '07-27', title: '《斗破苍穹》第598话更新', desc: '萧炎突破斗尊境界，新的征程开启', tag: '国漫更新' },
  { id: 4, date: '07-27', title: '《某天成为公主》第202话更新', desc: '公主与骑士的甜蜜互动引发读者热议', tag: '韩漫更新' },
  { id: 5, date: '07-26', title: '新作《暗影君主》正式上架', desc: '高人气韩国网漫作者新作，首话即登热度榜', tag: '新作上线' },
  { id: 6, date: '07-26', title: '《全职猎人》复刊确认', desc: '富坚义博宣布将在8月恢复连载', tag: '重磅消息' },
  { id: 7, date: '07-25', title: '虫虫动漫用户突破500万', desc: '感谢每一位热爱漫画的你一路相伴', tag: '站点动态' },
];

export const appData = {
  title: '随时随地，畅快追漫',
  description: '虫虫动漫全面适配移动端浏览器，无需下载安装，打开浏览器就能看。下拉式阅读在手机上体验更佳，单手滑动即可畅快追漫。将虫虫动漫添加到手机桌面，像使用App一样方便。',
  features: ['免安装即开即看', '下拉式流畅阅读', '全平台数据同步', '省流量快速加载'],
};

export const carouselData = [
  { id: 1, title: '韩漫特辑：热血与浪漫的双重奏', desc: '从《我独自升级》的燃炸战斗到《某天成为公主》的甜蜜心跳，韩漫用精致的全彩画风和独特的叙事节奏征服了全球读者。本期专题带你深入韩漫的多元世界。', tag: '韩漫', imgSeq: 'carousel-kr-01' },
  { id: 2, title: '日漫经典：那些年我们追过的神作', desc: '《全职猎人》《咒术回战》《海贼王》……这些名字承载着无数人的青春。日漫的魅力在于它从不设限——热血、悬疑、搞笑、治愈，总有一部能击中你的心。', tag: '日漫', imgSeq: 'carousel-jp-01' },
  { id: 3, title: '国漫之光：东方美学的数字表达', desc: '《斗破苍穹》《完美世界》《一人之下》……国漫正在用独特的东方叙事和日益精进的制作水准，向世界展示中国漫画的无限可能。', tag: '国漫', imgSeq: 'carousel-cn-01' },
  { id: 4, title: '下拉式阅读：漫画观看方式的革命', desc: '告别翻页，拥抱滚动。下拉式阅读让漫画画面自然衔接，彻底消除了翻页带来的阅读中断感。无论电脑还是手机，一滑到底的体验让追漫成为纯粹的享受。', tag: '特色', imgSeq: 'carousel-scroll-01' },
  { id: 5, title: '漫荒救星：冷门佳作挖掘计划', desc: '热榜之外，还有大量被埋没的好作品等待发现。我们每周精选评分高但热度尚低的优质漫画，帮你开拓新的阅读疆域。', tag: '推荐', imgSeq: 'carousel-hidden-01' },
];

export const featuresData = [
  { id: 1, icon: 'ri-stack-line', title: '三大分类精准导航', desc: '韩漫、日漫、国漫分类清晰，热门推荐与榜单助力快速发现好作品，从海量漫画中找到你的心头好只需几秒钟。' },
  { id: 2, icon: 'ri-scroll-to-bottom-line', title: '下拉式沉浸阅读', desc: '采用下拉式滚动浏览模式，画面自然衔接无中断，连续阅读一气呵成。手机端单手滑动，电脑端滚轮翻页，体验流畅自然。' },
  { id: 3, icon: 'ri-flashlight-line', title: '更新追踪永不错过', desc: '热门连载漫画每日同步更新，韩漫、日漫、国漫三大品类更新节奏清晰，收藏你喜欢的作品，紧跟每一话的最新动态。' },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '关于我们', href: '#about' },
  { label: '特色优势', href: '#features' },
  { label: '热门话题', href: '#topics' },
  { label: '读者评价', href: '#comments' },
  { label: '最新动态', href: '#updates' },
  { label: '常见问题', href: '#faq' },
];